import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {FrameworkModule} from "../framework/framework.module";
import {AccountSingleSelectEditControlComponent} from "./account/controls/account-single-select-edit-control.component";
import {AccountTypeSingleSelectEditControlComponent} from "./account-type/controls/account-type-single-select-edit-control.component";
import {AccountSingleSelectSearchControlComponent} from "./account/controls/account-single-select-search-control.component";
import {AccountMultiSelectSearchControlComponent} from "./account/controls/account-multi-select-search-control.component";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule
    ],
    declarations: [
        AccountSingleSelectEditControlComponent,
        AccountMultiSelectSearchControlComponent,
        AccountTypeSingleSelectEditControlComponent,
        AccountSingleSelectSearchControlComponent
    ],
    exports: [
        AccountSingleSelectEditControlComponent,
        AccountMultiSelectSearchControlComponent,
        AccountTypeSingleSelectEditControlComponent,
        AccountSingleSelectSearchControlComponent
    ]
})
export class AccountSharedModule {

}
